export default __webpack_public_path__ + "static/media/ImageSectionImageRight.24bcf82b.svg";